export const ONBOARDING_TOUR = {
  id: "onboarding",
  steps: [
    {
      popover: {
        title: "Bem-vindo ao Billing! 🎉",
        description:
          "Vamos fazer um tour rápido para você conhecer as principais funcionalidades.",
      },
    },
    {
      element: '[data-tour="sidebar-dashboard"]',
      popover: {
        title: "Dashboard",
        description:
          "Aqui você acompanha MRR, clientes ativos, inadimplência e receita em tempo real.",
        side: "right",
        align: "start",
      },
    },
    {
      element: '[data-tour="sidebar-plans"]',
      popover: {
        title: "Planos",
        description:
          "Configure os planos que seus clientes vão assinar. Defina preços, créditos, licenças e features.",
        side: "right",
        align: "start",
      },
    },
    {
      element: '[data-tour="sidebar-customers"]',
      popover: {
        title: "Clientes",
        description:
          "Gerencie seus clientes, crie assinaturas e acompanhe o uso de créditos e licenças.",
        side: "right",
        align: "start",
      },
    },
    {
      element: '[data-tour="sidebar-integrations"]',
      popover: {
        title: "Integrações",
        description:
          "Conecte seus sistemas via webhooks. O billing notifica automaticamente quando algo acontece.",
        side: "right",
        align: "start",
      },
    },
    {
      element: '[data-tour="sidebar-gateways"]',
      popover: {
        title: "Gateways",
        description:
          "Configure Asaas, Stripe ou dLocal Go para processar pagamentos.",
        side: "right",
        align: "start",
      },
    },
    {
      popover: {
        title: "Pronto para começar!",
        description:
          'Comece configurando um gateway e criando seu primeiro plano. Se precisar de ajuda, clique no "?" no canto da tela.',
      },
    },
  ],
};
